module.exports = __webpack_public_path__ + "fonts/comshiva.ef456235.woff";